import { Timestamp } from 'firebase/firestore';
import type { Application } from '../../types/application';

// 💰 통화 포맷팅
export const formatCurrency = (amount: number): string => {
  try {
    return new Intl.NumberFormat('ko-KR', {
      style: 'currency',
      currency: 'KRW',
      maximumFractionDigits: 0,
    }).format(amount);
  } catch (error) {
    console.warn('Currency formatting error:', error);
    return `₩${amount.toLocaleString()}`;
  }
};

// 📅 날짜 포맷팅
export const formatDate = (date: any): string => {
  try {
    if (!date) return '정보없음';
    if (typeof date === 'object' && date.seconds) {
      return new Date(date.seconds * 1000).toLocaleDateString('ko-KR');
    }
    if (date instanceof Date) {
      return date.toLocaleDateString('ko-KR');
    }
    return new Date(date).toLocaleDateString('ko-KR');
  } catch (error) {
    console.warn('Date formatting error:', error);
    return '정보없음';
  }
};

// 🔔 알림톡 날짜 포맷팅
export const formatAlertDate = (timestamp: Timestamp | { seconds: number } | undefined): string => {
  if (!timestamp) return '시간 정보 없음';
  
  try {
    const seconds = timestamp.seconds || (timestamp as any).seconds;
    if (!seconds) return '시간 정보 없음';
    
    const date = new Date(seconds * 1000);
    return date.toLocaleString('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  } catch (error) {
    console.warn('Date formatting error:', error);
    return '시간 정보 없음';
  }
};

// 📱 기기명 포맷팅
export const formatDeviceNames = (devices: Application['devices']): string => {
  if (!devices || devices.length === 0) return '기기정보없음';
  return devices.map(device => device.deviceModel).join(', ');
};

// 🔍 폼 검증
export const validateForm = (formData: any): Record<string, string> => {
  const errors: Record<string, string> = {};

  // 필요시 검증 로직 추가
  if (formData.priceOffer && isNaN(Number(formData.priceOffer))) {
    errors.priceOffer = '검수금액은 숫자여야 합니다';
  }
  
  if (formData.finalPrice && isNaN(Number(formData.finalPrice))) {
    errors.finalPrice = '최종금액은 숫자여야 합니다';
  }

  return errors;
}; 